import React from 'react';

import Spinner from './spinner';

export default (props) => (
  <div className="splash view">
    <h1>Calculon</h1>
    <Spinner size={48} color="skyblue"/>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/splash.js